<template>
    <transition name="fade">
        <div class="ConfirmPopup"
             v-if="isConfirmShown"
        >
            <div class="d-flex">
                <h5 class="ConfirmPopup--heading d-flex">{{ confirmationModal.title }}</h5>
                <i class="material-icons ml-auto"
                   :style="{'cursor': 'pointer'}"
                   @click="close"
                >
                    close
                </i>
            </div>
            <div>
                <h4 class="text-gray"> {{ confirmationModal.description }} </h4>
            </div>
            <div class="d-flex">
                <button
                        class="ConfirmPopup--button secondary-btn btn-center ml-auto"
                        type="button"
                        @click="close"
                >
                    No
                </button>
                <button
                        class="ConfirmPopup--button danger-btn btn-center"
                        type="button"
                        :disabled="isProgress"
                        @click="callbackHandler"
                >
                    Yes
                </button>
            </div>
        </div>
    </transition>
</template>

<script>
    import ClickOutside from 'vue-click-outside';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'ConfirmPopup',

        directives: { ClickOutside },

        computed: {
            ...mapGetters(['confirmationModal', 'isFadeShown', 'isConfirmShown', 'isProgress'])
        },

        methods: {
            ...mapActions(['toggleConfirmationModal']),

            async callbackHandler() {
                await this.confirmationModal.callback();
                this.close();
            },

            close() {
                this.toggleConfirmationModal(false);
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../assets/styles/variables/colors';

    .ConfirmPopup {
        z-index: 10;
        position: fixed;
        top: 200px;
        left: 50%;
        width: 400px;
        color: $Dark;
        padding: 30px 30px 20px;
        transform: translate(-50%, -50%);
        background: $White;
        border-radius: 4px;
        box-shadow: 0 0 20px 0 rgba(176, 186, 197, 0.25);
        font-size: 14px;

        @media screen and (max-width: 425px) {
            width: 310px;
        }

        &--heading {
            margin-bottom: 40px;
            font-weight: 400;
            font-size: 18px;
        }

        &--button {
            width: 100px;
            border-radius: 4px;

            &:last-child {
                margin-left: 20px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/popups/ConfirmPopup.vue